const CareerContent = () => {
  return (
    <div className="md:w-1/2 pr-8">
      <h2 className="text-3xl font-bold text-gray-800 mb-6">Careers</h2>
      <div className="space-y-4">
        <p>
          To keep up with our rapidly growing business, Grace Super Market is constantly expanding across departments. We are therefore on the look-out for qualified, experienced, dedicated and motivated staff with a varied mix of operational and technical skills.
        </p>
        <p>
          Working at Grace Super Market offers exciting new possibilities and growth opportunities, allowing you to follow your curiosity
        </p>
        <p>
          We believe in fostering a workplace where everyone is and feels included. Grace Mart Pvt Ltd also empowers its employees with the required training and skill building to help them climb the career ladder.
        </p>
        <div className="mt-6">
          <h3 className="text-red-600 font-bold mb-2">Caution</h3>
          <p className="text-gray-700">
            As a part of our team, you are constantly contributing to shaping the consumer's shopping experience. All official communication from Grace Mart Pvt Ltd related to employment will take place using only @Grace Mart Pvt Ltd No personal Email Ids will be used. Grace Mart Pvt Ltd does not charge any job seeker any money or deposit in exchange for employment offers and interviews. All communications are to Grace Mart Pvt Ltd only.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CareerContent;